import { apiWrapper } from '../helper/api-wrapper';

export const getItemReview = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/products/review/list/${
        payload?.rating
      }?query=${encodeURIComponent(payload?.query)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(
        payload?.limit
      )}&startDate=${encodeURIComponent(
        payload?.startDate
      )}&endDate=${encodeURIComponent(payload?.endDate)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getProjectReview = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/designer/review/list/${
        payload?.rating
      }?query=${encodeURIComponent(payload?.query)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(
        payload?.limit
      )}&startDate=${encodeURIComponent(
        payload?.startDate
      )}&endDate=${encodeURIComponent(payload?.endDate)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const replyItemReview = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/products/review/reply`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const replyProjecteview = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/designer/review/reply`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};
